import isEmpty from 'lodash/isEmpty';
import { fetchAll } from '../service/matches';
import { fetchFifaRanking } from '../service/fifaRanking';
import { loading } from '@actions';

export const loadMatches = () => async (dispatch, getState) => {
  const state = getState();
  const hasMatches = !isEmpty(state.matches);

  dispatch(loading(true));
  try {
    const [matchesRes, fifaRankingRes] = await Promise.all([
      hasMatches ? Promise.resolve({ data: state.matches }) : fetchAll(),
      fetchFifaRanking()
    ]);
    if (!hasMatches) {
      dispatch({ type: 'MATCHES_SET', payload: matchesRes.data });
    }
    dispatch({ type: 'FIFA_RANKING_SET', payload: fifaRankingRes.data });
    return hasMatches ? state.matches : matchesRes;
  } finally {
    dispatch(loading(false));
  }
};
